const positions = [
  {
    company: 'Microsoft',
    position: 'BI Engineer (vendor)',
    daterange: 'March 2021 - Present',
    overall: 'Architect and implement an automated security management workflow and powerBI dashboard for the Microsoft Mixed Reality security team.',
    points: [
      'Designed and developed the pipeline of risk register and policy document review with Azure DevOps.',
      'Architected and implemented the security workflow using ServiceNow GRC and integrated it with the current dashboard.',
    ],
  },
  {
    company: 'NewPoint.io',
    position: 'Software Engineer, Intern',
    daterange: 'June 2020 – October 2020',
    overall: 'Implemented and maintained a scalable, serverless backend for an online career fair web application.',
    points: [
      'Designed and developed a serverless backend architecture for job fair events features with DynamoDB, API Gateway, and Lambda.',
      'Developed and integrated JWT authentication with Auth0 and Lambda proxy integration for user login and API request validation.',
      'Utilized AWS SQS queues to invoke data process and update functions for better scalability and availability.',
    ],
  },
  {
    company: 'Beijing NorthStar S&T Development',
    position: 'Software Engineer, Intern',
    daterange: 'September 2017 - February 2018',
    overall: 'Upgraded and maintained an eCommerce web application in MERN stack, helping to increase order retention rate by 17%.',
    points: [
      'Refactored and launched full-stack features of order management and user dashboard to upgrade the user experiences.',
      'Designed and implemented schema structure in MongoDB, built backend REST APIs service following Middleware pattern.',
    ],
  },
  {
    company: 'Ernst & Young',
    position: 'Advisory service, Staff Associate Consultant',
    daterange: 'June 2017 - July 2018',
    points: [
      'Designed and prototyped a Business Process Management module of a risk management BI system to monitor, audit, and archive business legal documents.',
      'Develop a financial expenditure procedure using agglomerative hierarchical clustering (AHC) model to optimize expenditure approval standard and visualized in Tableau dashboard.',
    ],
  },
];

export default positions;
